export default __webpack_public_path__ + "static/media/Shoes- Ladies.042ed798.jpg";